/** Backend origin baked in at build time. Empty in local dev so Vite's proxy is used. */
export const API_ORIGIN = String(import.meta.env.VITE_BACKEND_URL ?? "").replace(/\/$/, "");

export function apiUrl(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${API_ORIGIN}${normalized}`;
}
